export default {
  title: "Reporte de Exclusiones"
  , filters: {
    fecha: "Fecha de Exclusión"
    , se: "SE"
    , seller: "Seller"
    , vendor: "Vendor"
    , campana: "Campaña"
    , status: "Status"
    , fechaev: "Fecha de Envío a Validador"
  }
  , tabla: {
    clave: "Clave"
    , nombreBase: "Nombre Base"
    , fecha: "Fecha"
    , se: "SE"
    , seller: "Seller"
    , nombre: "Nombre"
    , vendor: "Vendor"
    , campana: "Campaña"
    , status: "Status"
    , fechaev: "Fecha de Envío Validador"
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/reportes/reporteexclusiones.js